export const partsInventoryColumnConfig = [
  { id: "part_id", align: "left", label: "ID", alternateValue: 0 },
  { id: "part_name", align: "left", label: "Name", alternateValue: "-" },
  { id: "part_nicknm", align: "left", label: "Nick Name", alternateValue: "-" },
  { id: "part_desc", align: "left", label: "Description", alternateValue: "-" },
  { id: "vhc_id", align: "center", label: "Vehicle ID", alternateValue: "-" },
  { id: "qty", align: "center", label: "Quantity", alternateValue: 0 },
];
